import React from "react";
import { menuItemLeft, menuItemRight } from "../data/data";
import Copyright from "./Copyright";

const Footer = () => {
  return (
    <>
      <footer className="container-fluid container--footer">
        <div className="section-width">
          <ul className="footer-nav--list__wrapper">
            {menuItemLeft.map((menuItemLeft) => {
              return (
                <li className="footer-nav--link">
                  <a
                    className="footer-nav--item"
                    href={menuItemLeft.navigateTo}
                  >
                    {menuItemLeft.menuLable}
                  </a>
                </li>
              );
            })}
            {menuItemRight.map((menuItemRight) => {
              return (
                <li className="footer-nav--link">
                  <a
                    className="footer-nav--item"
                    href={menuItemRight.navigateTo}
                  >
                    {menuItemRight.menuLable}
                  </a>
                </li>
              );
            })}
          </ul>

          <div className="footer--contact__wrapper">
            <p className="contact-text">Contact</p>
            <p type='tel' className="contact-number">+91 6280017422</p>
          </div>
        </div>

        <Copyright />
      </footer>
    </>
  );
};
export default Footer;
